module.exports = __webpack_public_path__ + "static/img/ai-icon.97a8cda.svg";


//////////////////
// WEBPACK FOOTER
// ./static/2dsearch-ai/ai-icon.svg
// module id = rFMV
// module chunks = 1